// extracted by mini-css-extract-plugin
export var boldText = "_3s-4";
export var checkboxContainer = "_3s-6";
export var closeIcon = "_3s-g";
export var container = "_3s-0";
export var drawer = "_3s-8";
export var drawerContent = "_3s-9";
export var extraSmallText = "_3s-5";
export var fulfillmentGroupTable = "_3s-e";
export var largeText = "_3s-3";
export var loadingSpinnerContainer = "_3s-h";
export var mediumText = "_3s-2";
export var narrow = "_3s-f";
export var notificationLink = "_3s-j";
export var packageCheckIconContainer = "_3s-7";
export var slideoutHeaderContainer = "_3s-a";
export var slideoutModal = "_3s-c";
export var stickyHeaderWrapper = "_3s-b";
export var table = "_3s-i";
export var tableContainer = "_3s-d";
export var tertiaryText = "_3s-1";